export const orderPaymentMethodOptions = [
  { label: 'Chưa xác định', value: null },
  { label: 'Chuyển khoản', value: 'bank_transfer' },
  { label: 'Thanh toán khi nhận hàng (COD)', value: 'cod' },
];

export const getOrderPaymentMethodLabel = (order = {}) => {
  const paymentMethod = String(order?.payment_method || '').trim().toLowerCase();

  if (paymentMethod === 'cod') {
    return 'Thanh toán khi nhận hàng (COD)';
  }

  if (paymentMethod === 'bank_transfer') {
    return 'Chuyển khoản';
  }

  if (paymentMethod) {
    return order?.payment_method;
  }

  if (order?.payment_proof?.image) {
    return 'Chuyển khoản';
  }

  return 'Chưa xác định';
};